class Node {
    /** Node constructor : @param {number} value -order of node in bar - **/
    constructor(value) {
        this.value = value
        this.next = null
        this.prev = null
    }
}

export class CircularDoublyLinkedList {
    /**
     *  CircularDoublyLinkedList constructor : @param {number} value -order of node in bar -
     *  initialize function : @param {number} value - order of node in bar and set it as first node -
     *  append function : @param {number} value -append node in linkedList-
     *  nextNODE : @param {number} index -take index of node and return next node-
     *  prevNODE : @param {number} index -take index of node and return previous node-
     *  traverseToIndex :  @param {number} index -take index of node and return that node from head to tail-
     *  traverseToIndexminus :  @param {number} index -take index of node and return that node from tail to head-
     *  deleteHead : delete the first node
     *  deleteTail : delete the last node
     *  deleteMiddle : delete specific node from the middle
     *  delete : determine which function will call  deleteHead,deleteTail,deleteMiddle
     *  **/
    constructor(value) {
        this.head = null
        this.tail = null
        this.length = 0
        this.maxLength = 0

        if (value) {
            this.initialize(value)
        }
    }
    initialize(value) {
        const newNode = new Node(value)
        newNode.next = newNode
        newNode.prev = newNode
        this.head = newNode
        this.tail = newNode
        this.length++
            this.maxLength++
    }

    append(value) {
        if (this.length === 0) {
            this.initialize(value)
        } else {
            const newNode = new Node(value)
            newNode.prev = this.tail
            newNode.next = this.head
            this.head.prev = newNode
            this.tail.next = newNode
            this.tail = newNode
            this.length++
                this.maxLength++
        }

    }
    nextNODE(index) {
        let currentNode = this.head
        do {
            if (currentNode.value === index) {
                return currentNode.next
            } else {
                currentNode = currentNode.next
            }
        } while (currentNode !== this.head)

    }

    prevNODE(index) {
        let currentNode = this.tail
        do {
            if (currentNode.value === index) {
                return currentNode.prev
            } else {
                currentNode = currentNode.prev
            }
        } while (currentNode !== this.tail)

    }
    traverseToIndex(index) {
        let counter = 0
        let currentNode = this.head
        while (counter !== index) {
            currentNode = currentNode.next
            counter++
        }
        return currentNode
    }
    traverseToIndexminus(index) {
        let counter = this.length
        let currentNode = this.head
        while (counter !== index) {
            currentNode = currentNode.prev
            counter--
        }
        return currentNode

    }

    deleteHead() {
        if (this.length === 0) return null
        const currHead = this.head
        if (this.length === 1) {
            const headVal = this.head.value
            this.head = null
            this.tail = null
            this.length--
                return null
        }
        const headVal = this.head.value
        const newHead = this.head.next
        this.head = newHead
        this.tail.next = this.head
        this.head.prev = this.tail
        this.length--
            return this.head
    }

    deleteTail() {
        if (this.length === 0) return null
        if (this.length === 1) {
            const tailVal = this.tail.value
            this.head = null
            this.tail = null
            this.prev = null
            this.length--
                return null
        }
        const tailVal = this.tail.value
        const newTail = this.tail.prev
        newTail.next = this.head
        this.head.prev = newTail
        this.tail = newTail
        this.length--
            return this.head
    }
    deleteMiddle(index) {
        const preIdx = this.prevNODE(index)
        const targetIdx = preIdx.next
        const targetVal = targetIdx.value
        const nextIdx = targetIdx.next
        preIdx.next = nextIdx
        nextIdx.prev = preIdx
        this.length--
            return nextIdx
    }

    delete(index) {
        if (index === 0) {
            return this.deleteHead()
        }
        if (index >= this.length - 1) {
            return this.deleteTail()
        }
        if (index > 0 && index < this.length - 1) {
            return this.deleteMiddle(index)
        }
    }
}